import { createStyles } from "@material-ui/core";
export var styles = function (_theme) {
    return createStyles({
        root: {
            backgroundColor: "#EEF2FF",
            borderRadius: 60,
            textTransform: "none",
            margin: 0,
            textAlign: "center"
        },
        text: {}
    });
};
